var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "oc-logo", class: { animated: _vm.animated } },
    [
      _c("div", { staticClass: "oc-circle l1 s1 el1" }),
      _vm._v(" "),
      _c("div", { staticClass: "oc-circle l2 s3 el2" }),
      _vm._v(" "),
      _c("div", { staticClass: "oc-circle l2 s2 el3" }),
      _vm._v(" "),
      _c("div", { staticClass: "oc-circle l2 s2 el4" }),
      _vm._v(" "),
      _c("div", { staticClass: "oc-circle l3 s2 el5" }),
      _vm._v(" "),
      _c("div", { staticClass: "oc-circle l3 s2 el6" }),
      _vm._v(" "),
      _c("div", { staticClass: "oc-circle l4 s3 el7" }),
      _vm._v(" "),
      _c("div", { staticClass: "oc-circle l4 s2 el8" }),
      _vm._v(" "),
      _c("div", { staticClass: "oc-circle l4 s3 el9" })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }